export const KAMSATHI_THEME = {
  gold: '#C9A84C',
  goldLight: '#E2C170',
  goldDark: '#9A7A2E',
  goldFaint: '#FAF3E0',
  silver: '#B0B8C1',
  silverLight: '#D4DCE3',
  silverDark: '#7A8A96',
  bgDark: '#0D0D0D',
  bgCard: '#1A1A1A',
  bgCard2: '#222222',
  bgHover: '#2A2A2A',
  textPrimary: '#D4DCE3',
  textSecondary: '#7A8A96',
  textGold: '#C9A84C',
  textDark: '#0D0D0D',
  success: '#52C41A',
  warning: '#FAAD14',
  error: '#FF4D4F',
  info: '#1890FF',

  antdToken: {
    colorPrimary: '#C9A84C',
    colorBgBase: '#0D0D0D',
    colorTextBase: '#D4DCE3',
    colorBgContainer: '#1A1A1A',
    colorBgElevated: '#222222',
    colorBorder: 'rgba(201,168,76,0.25)',
    colorBorderSecondary: 'rgba(176,184,193,0.15)',
    colorFillSecondary: '#2A2A2A',
    colorFill: '#1A1A1A',
    borderRadius: 8,
    fontFamily: "'Segoe UI', Arial, sans-serif",
    colorPrimaryHover: '#E2C170',
    colorPrimaryActive: '#9A7A2E',
  },
};

export const CARD_STYLE = {
  background: '#1A1A1A',
  border: '0.5px solid rgba(201,168,76,0.25)',
  borderRadius: 10,
};

export const GOLD_GRADIENT = 
  'linear-gradient(135deg, #E2C170, #9A7A2E)';